<cc-file-drop
  *ngIf="!bucketFileName"
  [url]="fileUrl"
  [type]="fileType"
  (refresh)="update.next()"
></cc-file-drop>
<cc-file-drop-player
  *ngIf="bucketFileName"
  [voiceMailFileName]="fileName"
  [url]="fileUrl"
  (refresh)="update.next()"
  (remove)="onRemove()"
></cc-file-drop-player>
